import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import fs from 'fs';
import JSZip from 'jszip';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  Divider, 
  MenuItem,
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { toast } from 'react-toastify';

import { IsNoU } from 'common/utils';

import { meterTypes } from 'common/datas';

const useStyles = makeStyles(theme => ({
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  listitem_align: {
    //alignItems: 'center',
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  registerListItemFilePath: {
    //marginLeft: theme.spacing(2),
    width: '320px',
  },
  registerListItemUpload: {
    marginLeft: theme.spacing(2),
  },
}));
  

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const RegAndEditAddressDB = (props) => {

  const {
    className,
    openDialog,
    onClickCloseDialog,
    onClickSaveAddressDB,
    editAddressDB,
    modeRegisterDlg,
    userName,
  } = props;

  const classes = useStyles();

  

  const [addressDBName, setAddressDBName] = useState('');
  const [dbFile, setDbFile] = useState(null);
  const [dbFileName, setDbFileName] = useState('');
  const [prevDbFile, setPrevDbFile] = useState('');
  const [selectedMeter, setSelectedMeter] = useState('');
  const [addressDBDescription, setAddressDBDescription] = useState('');

  useEffect(() => {
  
    if (editAddressDB === null) {
      setAddressDBName('');
      setDbFile(null);
      setPrevDbFile('');
      setSelectedMeter('');
      setAddressDBDescription('');
    }
    else {
      setAddressDBName(editAddressDB.name);
      setDbFile(null);
      setPrevDbFile(editAddressDB.file);
      setSelectedMeter(editAddressDB.meter_type);
      setAddressDBDescription(editAddressDB.description);
    }

  }, [editAddressDB]);

  const renderNewAddressDB = (
    <ListItem>
      <TextField 
        className={classes.registerListItemInput}
        required 
        id="outlined-basic1" 
        //variant="outlined" 
        label="파일 첨부"
        //placeholder="플레이어 이름을 입력하세요..."
        fullWidth
        value={dbFileName}
        disabled={true}
        //onChange={event=> setAddressDBName(event.target.value)}
        />
      <Button
        className={classes.registerListItemUpload}
        variant="contained"
        component="label"
      >
        파일선택
        <input
          type="file"
          accept=".db"
          style={{ display: "none" }}
          onChange={e => {
            const file = e.target.files[0];
            if (file !== null && file !== undefined) {
            // console.log('player-package-name -> ' + getPackageName(file));
            setDbFile(file);
            setDbFileName(file.name);
            }
            //console.log(file);
          }}
        />
      </Button>
    </ListItem>
  );

  const renderEditAddressDB = (
    <>
      <ListItem >
        <TextField 
          className={classes.registerListItemInput}
          required 
          id="id_prev_file" 
          //variant="outlined" 
          label="파일 첨부"
          //placeholder="플레이어 이름을 입력하세요..."
          fullWidth
          value={prevDbFile}
          disabled={true}
          //onChange={event=> setAddressDBName(event.target.value)}
          />
      </ListItem>
      <ListItem>
        <TextField 
          className={classes.registerListItemInput}
          required 
          id="id_new_file" 
          //variant="outlined" 
          label="신규 파일"
          //placeholder="플레이어 이름을 입력하세요..."
          helperText="기존등록파일명이 같을경우 신규수정파일 등록 불가 합니다"
          fullWidth
          value={dbFileName}
          disabled={true}
          //onChange={event=> setAddressDBName(event.target.value)}
          />
        <Button
          className={classes.registerListItemUpload}
          variant="contained"
          component="label"
        >
          파일선택
          <input
            type="file"
            accept=".db"
            style={{ display: "none" }}
            onChange={e => {
              const file = e.target.files[0];
              if (file !== null && file !== undefined) {
                let fileName = file.name.toString();
                let prevName = undefined;
                if (!IsNoU(prevDbFile) && prevDbFile.length > 0) {
                  prevName = prevDbFile.toString();
                }
                if (!IsNoU(prevName) && fileName === prevName) {
                  setDbFile(null);
                  setDbFileName('');
                  toast('기존 등록 파일명과 동일합니다.');
                }
                else {
                  setDbFile(file);
                  setDbFileName(file.name);
                }
              }
              //const file = e.target.files[0];
              
              //console.log(file);
            }}
          />
        </Button>
      </ListItem>
    </>
  );

  return (
    <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h5" className={classes.title} color="inherit">
            지역DB
          </Typography>
          <Button autoFocus color="inherit" onClick={() => {
            
            if (IsNoU(addressDBName) || addressDBName.length <= 0) {
              toast('지역DB 이름을 입력하세요');
              return ;
            }

            if (dbFile === null) {
              toast('DB 파일을 선택하세요');
              return ;
            }

            if (IsNoU(selectedMeter) || selectedMeter.length <= 0) {
              toast("미터기 종료를 선택하세요.");
              return ;
            }

            const newAddressDB = {
              name: addressDBName,
              file: dbFile,
              meter_type: selectedMeter,
              modified_user: userName,
              modified_at: new Date(),
              description: addressDBDescription,
              prev_file: prevDbFile,
            };

            if (!IsNoU(editAddressDB))
              newAddressDB.id = editAddressDB.id;

            onClickSaveAddressDB(newAddressDB);
          }}>
            저장
          </Button>
        </Toolbar>
      </AppBar>

      <List>
        <ListItem className={classes.listitem_align}>
        <Card
          className={clsx(classes.card_root, className)}
        >
          <CardHeader
            className={classes.card_header}
            title={modeRegisterDlg ? '지역DB 등록' : '지역DB 수정'}
            subheader='*표시는 필수 항목'
          />
          <CardContent className={classes.content}>
            <List>
              <ListItem className={classes.listitem_align}>
                <TextField 
                      className={classes.registerListItemInput}
                      required 
                      id="outlined-basic1" 
                      //variant="outlined" 
                      label="지역DB 이름"
                      placeholder="지역DB 이름을 입력하세요..."
                      fullWidth
                      value={addressDBName}
                      onChange={event=> setAddressDBName(event.target.value)}
                      />
              </ListItem>
              <Divider />
              { modeRegisterDlg ? renderNewAddressDB : renderEditAddressDB }
              <Divider />
              <ListItem>
                <TextField
                  className={classes.registerListItemInput}
                  id="outlined-select-meter"
                  label='미터기 타입'
                  select
                  required
                  value={selectedMeter}
                  onChange={event=> setSelectedMeter(event.target.value)}
                  helperText=""
                  //variant="outlined"
                  margin="dense"
                >
                  {meterTypes.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

              </ListItem>
              <ListItem>
                <TextField 
                  className={classes.registerListItemInput}
                  //required 
                  id="id_player_description" 
                  //variant="outlined" 
                  label="DB 설명"
                  placeholder="DB 설명을 입력하세요..."
                  fullWidth
                  value={addressDBDescription}
                  onChange={event=> setAddressDBDescription(event.target.value)}
                  />
              </ListItem>
            </List>
          </CardContent>
          </Card>
        </ListItem>
      </List>
    </Dialog>
  );
}

export default RegAndEditAddressDB;